import { render, staticRenderFns } from "./_ClientSearch.vue?vue&type=template&id=2f310ebe"
import script from "./_ClientSearch.vue?vue&type=script&lang=js"
export * from "./_ClientSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports